import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=4b9dc5a8&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=4b9dc5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9dc5a8",
  null
  
)

export default component.exports